"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _excluded = ["variant"];

var StatusBadge = function StatusBadge(_ref) {
  var _ref$variant = _ref.variant,
      variant = _ref$variant === void 0 ? 'default' : _ref$variant,
      props = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  return (0, _preact.h)("div", (0, _extends2.default)({
    className: "status-badge status-badge--".concat(variant)
  }, props));
};

var _default = StatusBadge;
exports.default = _default;